import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { StoredPhotoBook } from 'services/PhotoBook/photoBookSaver.types'
import type { PhotoBankStore } from 'stores/photoBankStore/PhotoBankStore'
import { type PhotoBookCartItem } from '../../CartItem'
import { createBaseCartMetadata } from '../CartItemAdapter.utils'
import { computePhotoBookWarnings } from './photoBookWarnings'
import { buildCover } from './photoBookCover'

export function buildPhotoBookCartItem(
  bookData: StoredPhotoBook | null,
  photoBankStore: PhotoBankStore
): PhotoBookCartItem | null {
  if (!bookData) return null

  const pageSides = bookData.pages.flatMap((page) => [page.front, page.back])
  const pageCount =
    pageSides.filter((pageSide) => pageSide.photos.length > 0).length ||
    pageSides.length
  const photosCount = pageSides.reduce(
    (sum, pageSide) => sum + pageSide.photos.length,
    0
  )
  const warnings = computePhotoBookWarnings(
    bookData,
    photosCount,
    photoBankStore
  )

  return {
    id: bookData.bookId,
    productType: PRODUCT_TYPES.PHOTO_BOOK,
    quantity: bookData.quantity,
    ...(warnings.length > 0 && { warnings }),
    metadata: {
      ...createBaseCartMetadata(),
      size: bookData.size,
      pageCount,
      photosCount,
      cover: buildCover(bookData.cover, photoBankStore),
    },
  }
}
